<div class="login-container">
    <div class="login-box">
        <h1 class="login-title">Login</h1>
        <form [formGroup]="loginForm" (ngSubmit)="submit()">
            <div class="input-container">
                <label for="email">Email</label>
                <input formControlName="email" id="email" type="email" class="custom-input"
                    placeholder="Enter your email" />
                <app-form-errors [control]="loginForm.controls['email']"></app-form-errors>
            </div>
            <div class="input-container">
                <label for="password">Password</label>
                <input formControlName="password" id="password" type="password" class="custom-input"
                    placeholder="Enter your password" />
                <app-form-errors [control]="loginForm.controls['password']"></app-form-errors>
            </div>

            <div class="forgot-password-link">
                <a [routerLink]="['/forgot-password']">Forgot Password?</a>
            </div>

            <button pButton [loading]="loadingSubmit" type="submit" class="p-button custom-btn"
                [disabled]="loadingSubmit">Login</button>
        </form>
    </div>
</div>